import React from 'react'
import Form from './Form'

function CompanyFormContent({ formId, company, onBack, onNext }) {
  return (
    <>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content new-brp-modal">
          <div className="modal-header">
            <div className="dome-h2 dome-color-dark-grey">Edit Company</div>
          </div>
          <div className="modal-body">
            <Form id={formId} company={company} onSubmit={onNext} />
          </div>
          <div className="modal-footer">
            <button
              className="dome-btn dome-btn-link dome-btn-link-cancel pull-left dome-color-med-grey"
              data-dismiss="modal"
              onClick={onBack}
            >
              cancel
            </button>
            <button type="submit" form={formId} className="dome-btn dome-btn-base dome-btn-aqua-stroke pull-right">
              save
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default CompanyFormContent
